'use client';

import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';

export const CopyTokensHelper = () => {
  const { toast } = useToast();

  const extractTokensFromProd = () => {
    const prompt = `
Скопируйте эти куки с ПРОДАКШЕНА (DevTools → Application → Cookies):

1. __Secure-next-auth.session-token
2. __Host-next-auth.csrf-token

Вставьте их сюда в формате:
__Secure-next-auth.session-token=значение_токена
__Host-next-auth.csrf-token=значение_csrf

Или просто весь cookie header.`;

    const userInput = window.prompt(prompt);
    if (userInput) {
      processTokens(userInput);
    }
  };

  const processTokens = (input: string) => {
    try {
      // Парсим токены из разных форматов
      let sessionToken = '';
      let csrfToken = '';

      // Формат 1: построчно
      if (input.includes('__Secure-next-auth.session-token=')) {
        const sessionMatch = input.match(
          /__Secure-next-auth\.session-token=([^;\s\n]+)/,
        );
        const csrfMatch = input.match(
          /__Host-next-auth\.csrf-token=([^;\s\n]+)/,
        );

        sessionToken = sessionMatch?.[1] || '';
        csrfToken = csrfMatch?.[1] || '';
      }

      // Формат 2: cookie header
      else if (input.includes('Cookie:')) {
        const sessionMatch = input.match(
          /__Secure-next-auth\.session-token=([^;]+)/,
        );
        const csrfMatch = input.match(/__Host-next-auth\.csrf-token=([^;]+)/);

        sessionToken = sessionMatch?.[1] || '';
        csrfToken = csrfMatch?.[1] || '';
      }

      if (sessionToken && csrfToken) {
        setTokensToLocalhost(sessionToken, csrfToken);
        toast({
          title: 'Токены успешно установлены!',
          description: 'Теперь перезагрузите страницу',
          variant: 'default',
        });
      } else {
        throw new Error('Не удалось найти токены');
      }
    } catch (error) {
      toast({
        title: 'Ошибка парсинга токенов',
        description: 'Проверьте формат введенных данных',
        variant: 'error',
      });
    }
  };

  const setTokensToLocalhost = (sessionToken: string, csrfToken: string) => {
    // Устанавливаем куки для localhost
    const domain = window.location.hostname;
    const secure = window.location.protocol === 'https:';

    // Для localhost используем обычные имена без префиксов
    document.cookie = `next-auth.session-token=${sessionToken}; Path=/; Domain=${domain}; ${secure ? 'Secure;' : ''} HttpOnly=false; SameSite=Lax`;
    document.cookie = `next-auth.csrf-token=${csrfToken}; Path=/; Domain=${domain}; ${secure ? 'Secure;' : ''} HttpOnly=false; SameSite=Lax`;
    // eslint-disable-next-line no-console
    console.log('Установлены куки:');
    // eslint-disable-next-line no-console
    console.log(
      'next-auth.session-token:',
      sessionToken.substring(0, 20) + '...',
    );
    // eslint-disable-next-line no-console
    console.log('next-auth.csrf-token:', csrfToken.substring(0, 20) + '...');
  };

  const getCurrentTokens = () => {
    const sessionToken =
      getCookie('next-auth.session-token') ||
      getCookie('__Secure-next-auth.session-token');
    const csrfToken =
      getCookie('next-auth.csrf-token') ||
      getCookie('__Host-next-auth.csrf-token');
    // eslint-disable-next-line no-console
    console.log('=== ТЕКУЩИЕ ТОКЕНЫ ===');
    // eslint-disable-next-line no-console
    console.log(
      'Session token:',
      sessionToken ? sessionToken.substring(0, 20) + '...' : 'НЕТ',
    );
    // eslint-disable-next-line no-console
    console.log(
      'CSRF token:',
      csrfToken ? csrfToken.substring(0, 20) + '...' : 'НЕТ',
    );
    // eslint-disable-next-line no-console
    console.log('====================');

    toast({
      title: 'Токены выведены в консоль',
      description: `Session: ${sessionToken ? 'ЕСТЬ' : 'НЕТ'}, CSRF: ${csrfToken ? 'ЕСТЬ' : 'НЕТ'}`,
    });
  };

  const clearTokens = () => {
    // Очищаем все возможные варианты токенов
    const tokenNames = [
      'next-auth.session-token',
      '__Secure-next-auth.session-token',
      'next-auth.csrf-token',
      '__Host-next-auth.csrf-token',
    ];

    tokenNames.forEach((name) => {
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    });

    toast({
      title: 'Токены очищены',
      description: 'Перезагрузите страницу',
    });
  };

  const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return null;
  };

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-3">
      <h4 className="font-semibold text-blue-900">
        🔑 Копирование токенов с прода
      </h4>

      <div className="space-y-2">
        <Button
          onClick={extractTokensFromProd}
          size="sm"
          className="w-full bg-blue-600 hover:bg-blue-700"
        >
          📥 Вставить токены с прода
        </Button>

        <Button
          onClick={getCurrentTokens}
          size="sm"
          className="w-full bg-gray-600 hover:bg-gray-700"
        >
          👁️ Показать текущие токены
        </Button>

        <Button
          onClick={clearTokens}
          size="sm"
          className="w-full bg-red-600 hover:bg-red-700"
        >
          🗑️ Очистить токены
        </Button>
      </div>

      <div className="text-xs text-blue-700 bg-blue-100 p-2 rounded">
        <strong>Инструкция:</strong>
        <ol className="list-decimal list-inside mt-1 space-y-1">
          <li>Откройте прод сайт и войдите в систему</li>
          <li>DevTools → Application → Cookies → выберите домен сайта</li>
          <li>
            Скопируйте значения __Secure-next-auth.session-token и
            __Host-next-auth.csrf-token
          </li>
          <li>Нажмите Вставить токены с прода и вставьте их</li>
          <li>Перезагрузите localhost</li>
        </ol>
      </div>
    </div>
  );
};
